export const PoweredBy = () => {
  return (
    <div className="mt-8 text-sm text-gray-400">
      Powered by <a href="https://fortworx.com" className="text-blue-500">Fortworx</a>
    </div>
  );
}
